import { render, staticRenderFns } from "./uservisitrecords0512archive-add-or-update.vue?vue&type=template&id=7bf612ec&"
import script from "./uservisitrecords0512archive-add-or-update.vue?vue&type=script&lang=js&"
export * from "./uservisitrecords0512archive-add-or-update.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports